// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1169":"b916c509f6d3dc6a","4750":"63ba4d079ec688e8","4825":"0d354a87dc6649e3","5442":"a4a396e06bfdb568","5645":"5ab79c46dc1489f0","6970":"034488ebbd5f689c","7964":"c8105abcece863ea","8928":"b003e8f76872f7c5","9026":"7dec75df64664809"}[chunkId] + ".js";
};